import type { Editor } from "@tiptap/react";
import type { VariantProps } from "class-variance-authority";
import { ChevronDown, ListIcon, ListOrderedIcon } from "lucide-react";
import * as React from "react";

import type { FormatAction } from "../../types";
import { ToolbarSection } from "../toolbar-section";

import type { toggleVariants } from "@/components/ui/toggle";

type ListItemAction = "orderedList" | "bulletList";
interface ListItem extends FormatAction {
  value: ListItemAction;
}

const formatActions: ListItem[] = [
  {
    value: "orderedList",
    label: "Numbered list",
    icon: <ListOrderedIcon className='size-5' />,
    isActive: (editor) => editor.isActive("orderedList"),
    action: (editor) => editor.chain().focus().toggleOrderedList().run(),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleOrderedList().run(),
    shortcuts: ["mod", "shift", "7"],
  },
  {
    value: "bulletList",
    label: "Bullet list",
    icon: <ListIcon className='size-5' />,
    isActive: (editor) => editor.isActive("bulletList"),
    action: (editor) => editor.chain().focus().toggleBulletList().run(),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleBulletList().run(),
    shortcuts: ["mod", "shift", "8"],
  },
];

interface ListMenuBarProps extends VariantProps<typeof toggleVariants> {
  editor: Editor;
  activeActions?: ListItemAction[];
  mainActionCount?: number;
}

export const ListMenuBar: React.FC<ListMenuBarProps> = ({
  editor,
  activeActions = formatActions.map((action) => action.value),
  mainActionCount = 0,
  size,
  variant,
}) => {
  return (
    <ToolbarSection
      editor={editor}
      actions={formatActions}
      activeActions={activeActions}
      mainActionCount={mainActionCount}
      dropdownIcon={
        <>
          <ListIcon className='size-5' />
          <ChevronDown className='size-5' />
        </>
      }
      dropdownTooltip='Lists'
      size={size}
      variant={variant}
    />
  );
};

ListMenuBar.displayName = "ListMenuBar";

export default ListMenuBar;
